"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniKChart_old = exports.MiniKChart = void 0;
var react_1 = __importStar(require("react"));
/**
 * K线图svg版
 * @param props
 * @returns
 */
function MiniKChart(props) {
    var _a, _b, _c;
    var ref_container = (0, react_1.useRef)(null);
    var id = "quotechart" + Math.floor(Math.random() * 1000000 + 1);
    var thischart = (0, react_1.useRef)(null);
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : 240;
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : 180;
    var timeout = (_c = props.timeout) !== null && _c !== void 0 ? _c : 60;
    var draw = function () {
        if (window.miniquotechart2023) {
            var option = {
                container: document.getElementById(id),
                width: width,
                height: height,
                type: 'k',
                bar_width_ratios: 0.55,
                count: 48,
                fq: 'qfq',
                // bar_width_ratios:0.9,
                quotecode: props.quotecode,
                ut: "bd1d9ddb04089700cf9c27f6f7426281",
                refreshTime: timeout * 1000
            };
            if (thischart.current == null) {
                thischart.current = new window.miniquotechart2023.KLine(option);
            }
            thischart.current.draw();
        }
    };
    (0, react_1.useEffect)(function () {
        if (window.miniquotechart2023 && ref_container) {
            draw();
        }
    }, [props.quotecode]);
    return (react_1.default.createElement("div", { className: "minikchart" },
        react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(props.quotecode) },
            react_1.default.createElement("div", { id: id, ref: ref_container }))));
}
exports.MiniKChart = MiniKChart;
/**
 * 迷你K线图
 * @returns
 */
function MiniKChart_old(props) {
    var _a, _b, _c;
    var id = "quotechart" + Math.floor(Math.random() * 1000000 + 1);
    var thischart = (0, react_1.useRef)(null);
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : 240;
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : 180;
    var timeout = (_c = props.timeout) !== null && _c !== void 0 ? _c : 60;
    var draw = function () {
        if (window.emcharts3) {
            var option = {
                container: '#' + id,
                code: props.quotecode,
                newquote: true,
                width: width,
                height: height,
                token: '4f1862fc3b5e77c150a2b985b12db0fd',
                color: {
                    border: '#bbd4e8'
                },
                bigImg: {
                    stauts: 'show'
                },
                padding: {
                    left: 1,
                    right: 0,
                    top: 10,
                    bottom: 10
                }
            };
            if (thischart.current == null) {
                thischart.current = new window.emcharts3.kmini(option);
            }
            thischart.current.draw();
        }
    };
    (0, react_1.useEffect)(function () {
        if (window.emcharts3) {
            var cd_1;
            if (timeout > 0) {
                cd_1 = setInterval(function () {
                    draw();
                }, timeout * 1000);
            }
            draw();
            return function () {
                clearInterval(cd_1);
            };
        }
    }, [props.quotecode]);
    return (react_1.default.createElement("div", { className: "minikchart" },
        react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(props.quotecode) },
            react_1.default.createElement("div", { id: id }))));
}
exports.MiniKChart_old = MiniKChart_old;
